(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/brand-mapping/assets/javascripts/brands/subproduct/vm-tipset-europa.js') >= 0) return;  svs.modules.push('/components/lb-utils/brand-mapping/assets/javascripts/brands/subproduct/vm-tipset-europa.js');
"use strict";

let products;
if (svs.isServer) {
  products = require('@svenskaspelab/trinidad-core').core.components.require('utils', 'products');
} else {
  products = svs.utils.products;
}

const _products = products,
  getProductClassName = _products.getProductClassName,
  productIds = _products.productIds;

const model = {
  brand: getProductClassName(productIds.EUROPATIPSET),
  brandLogo: 'vm-tipset-europa',
  brandMenuColor: 'white'
};

const toExport = model;

if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.lbUtils.brandMapping.brands.subproduct.vmTipsetEuropa', toExport);
}


 })(window);